// src/quizData.js
export const doorSupervisorQuestions = [
    {
        question: "What is the primary role of a Door Supervisor?",
        options: ["Serve drinks", "Monitor CCTV", "Ensure safety and security", "Clean the venue"],
        answer: "Ensure safety and security",
    },
    {
        question: "Which law governs the use of reasonable force?",
        options: [
            "Human Rights Act 1998",
            "Criminal Law Act 1967",
            "Licensing Act 2003",
            "Equality Act 2010",
        ],
        answer: "Criminal Law Act 1967",
    },
    // Add 13 more questions...
];
